import styled from 'styled-components';
import { Box } from './layout/Box';

export const Sticker = styled(Box).withConfig({ displayName: 'Sticker' }).attrs({
    position: 'absolute',
    top: -0.5,
    right: -0.5,
    width: 12,
    height: 12,
    backgroundColor: 'var(--accent-purple)',
    borderRadius: '50%',
    border: '2px solid var(--background-primary)',
})``;
